<template>
  <Row style="height: 100%">
    <Col style="background: #fff; height: 100%" span="4">
      <div v-if="loading" class="loading-div">
        <Button loading shape="circle" type="primary"></Button>
        <div>loading...</div>
      </div>
      <Card style="height: 100%">
        <Tabs @on-click="langChange" :value="lang">
          <TabPane
            v-for="item in langList"
            :key="item.value"
            :label="item.label"
            :name="item.value"
          />
        </Tabs>
        <div class="search-inp">
          <!-- <Input :placeholder="$t('keyword')" style="width:84%;" /> -->
          <Button
            style="margin-left: 0px; width: 100%"
            type="success"
            icon="md-add"
            @click.stop="addClass({ pid: 0 })"
            >{{ $t("add") + $t("one_class") }}</Button
          >
        </div>

        <Menu
          v-if="classList.length"
          style="width: 100%; height: calc(100 - 42px); overflow-y: auto"
          :activeName="activeName"
          @on-select="selectClass"
        >
          <template v-for="(cl, clIdx) in classList">
            <Submenu v-if="cl.children" :key="cl.id + cl.title" :name="cl.id">
              <template #title>
                <Poptip trigger="hover" transfer placement="right" width="80">
                  {{ cl.title }}
                  <template #content>
                    <Button
                      v-for="(item, index) in btnList"
                      :key="index"
                      style="margin-right: 5px"
                      :type="item.type"
                      :icon="item.icon"
                      size="small"
                      @click.stop="classFun(item.event, cl)"
                    ></Button>
                  </template>
                </Poptip>
              </template>
              <MenuItem
                v-for="(ch, chIdx) in cl.children"
                :key="chIdx"
                :name="ch.id"
              >
                <Poptip trigger="hover" transfer placement="right" width="80">
                  {{ ch.title }}
                  <template #content>
                    <template v-for="(item, index) in btnList">
                      <Button
                        v-if="index > 0"
                        :key="index"
                        style="margin-right: 5px"
                        :type="item.type"
                        :icon="item.icon"
                        size="small"
                        @click.stop="classFun(item.event, ch)"
                      ></Button>
                    </template>
                  </template>
                </Poptip>
              </MenuItem>
            </Submenu>
            <MenuItem v-else :key="clIdx + cl.title" :name="cl.id">
              <Poptip trigger="hover" transfer placement="right" width="80">
                {{ cl.title }}
                <template #content>
                  <Button
                    v-for="(item, index) in btnList"
                    :key="index"
                    style="margin-right: 5px"
                    :type="item.type"
                    :icon="item.icon"
                    size="small"
                    @click.stop="classFun(item.event, cl)"
                  ></Button>
                </template>
              </Poptip>
            </MenuItem>
          </template>
        </Menu>
        <div class="no-data" v-else>{{ $t("NoData") }}~</div>
      </Card>
    </Col>
    <Col style="height: 100%" span="20">
      <cTable
        ref="table"
        :fields="fields"
        :header="header"
        :methods="methods"
        :modals="modals"
        :config="config"
      >
        <!-- 新增文档 -->
        <template #ADDDOCUMENT="{ params, visible }">
          <div style="wdith: 100%">
            <editor v-if="visible" @change="edChange" :text="params.content" />
          </div>
        </template>
      </cTable>
    </Col>
  </Row>
</template>

<script>
import {
  getDocumentList,
  addDocument,
  editDocument,
  deleteDocument,
} from "@/api/documentManagement/documentList";
import {
  getClassList,
  addClass,
  editClass,
  deleteClass,
} from "@/api/documentManagement/documentClass";
import editor from "@/components/mavonEditor/index";
import cTable from "@/base/common/index";
import { t } from "vxe-table";
export default {
  name: "documentList",
  components: {
    cTable,
    editor,
  },
  created() {
    this.getClassListFun();
  },
  methods: {
    // 文档内容编辑
    edChange(content) {
      let that = this.$refs["table"].getModal("addDocument").$refs["form"];
      that.formData["content"] = content;
      that.$refs.form.validateField("content");
    },

    // 分类选择
    selectClass(name) {
      this.$nextTick(() => {
        this.activeName = name;
        this.$refs["table"].getList();
      });
    },

    // 语言选择
    langChange(val) {
      if (val != this.lang) {
        this.lang = val;
        this.activeName = 0;
        this.getClassListFun();
      }
    },
    // 获取分类列表
    getClassListFun() {
      this.loading = true;
      getClassList({ lang: this.lang }).then((res) => {
        this.classList = res.data.payload;
        if (!res.data.payload.length) {
          this.$refs["table"].list = [];
        }
        if (res.data.payload.length && !this.activeName) {
          this.selectClass(
            res.data.payload.length
              ? res.data.payload[0].children
                ? res.data.payload[0].children[0].id
                : res.data.payload[0].id
              : 0
          );
        }
        this.loading = false;
      });
    },
    // 文档分类事件
    classFun(type, obj) {
      switch (type) {
        case "add":
          this.addClass(obj);
          break;
        case "edit":
          this.editClass(obj);
          break;
        case "del":
          this.deleteClass(obj);
          break;
        default:
          break;
      }
    },
    addClass(obj) {
      this.$refs["table"]
        .getModal("add")
        .open(
          { pid: obj.id ? obj.id : 0, type: "addClass", lang: this.lang },
          function () {
            let str = obj.title
              ? this.$t("add") + " [ " + obj.title + " ]" + this.$t("two_class")
              : this.$t("add") + this.$t("one_class");
            this.setTitle(str);
          }
        );
    },
    editClass(obj) {
      obj["type"] = "editClass";
      this.$refs["table"].getModal("add").open(obj, function () {
        this.setTitle(
          this.$t("modify") +
            "[ " +
            obj.title +
            " ] " +
            this.$t("documentClass")
        );
      });
    },
    deleteClass(obj) {
      this.$Modal.confirm({
        title:
          thist.$t("delete") +
          " [ " +
          obj.title +
          " ] " +
          this.$t("documentClass"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          this.$refs["table"]
            .handleRequestMethods("deleteClass", obj.id, true, true)
            .then((res) => {
              if (obj.id == this.activeName) {
                this.activeName = 0;
              }
              this.getClassListFun();
            });
        },
      });
    },
  },
  data() {
    return {
      activeName: 0,
      loading: false,
      lang: "zh-CN",
      langList: [
        {
          label: this.$t("Chinese"),
          value: "zh-CN",
        },
        {
          label: this.$t("English"),
          value: "en-US",
        },
      ],
      classList: [],
      btnList: [
        {
          type: "success",
          icon: "md-add",
          event: "add",
        },
        {
          type: "warning",
          icon: "ios-create-outline",
          event: "edit",
        },
        {
          type: "error",
          icon: "md-trash",
          event: "del",
        },
      ],
      methods: {
        list: (p) => {
          p["category_id"] = this.activeName;
          p["lang"] = this.lang;
          return getDocumentList(p);
        },
        addDocument,
        editDocument,
        deleteDocument,
        getClassList,
        addClass,
        editClass,
        deleteClass,
      },
      config: {
        height: 630,
        isGetList: true,
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok: ({ row, close }) => {
              this.$refs["table"]
                .handleRequestMethods(row.type, row, true, true)
                .then((res) => {
                  this.getClassListFun();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              lang: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              title: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              sort: [
                {
                  required: true,
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ lang: 24 }, { title: 24 }, { sort: 24 }],
          fields: [
            {
              name: () => this.$t("language"),
              key: "lang",
              placeholder() {
                return this.$t("select") + this.$t("language");
              },
              component: "Radio",
              options: [
                {
                  label: this.$t("Chinese"),
                  value: "zh-CN",
                  disabled: () => true,
                },
                {
                  label: this.$t("English"),
                  value: "en-US",
                  disabled: () => true,
                },
              ],
              default: "zh-CN",
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("documentClassName"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("documentClassName");
              },
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              default: 99,
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
            },
          ],
        },
        addDocument: {
          type: "add",
          slots: ["ADDDOCUMENT"],
          methods: {
            ok({ row, close, btn }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods(this.type, data, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
            cancel() {
              close();
            },
          },
          config: {
            modalBind: {
              width: "80",
              // "class-name": "vertical-center-modal",
              draggable: true,
              sticky: true,
              scrollable: true,
              styles: {
                top: "30px",
              },
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  type: "string",
                  trigger: "blur",
                },
              ],
              lang: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              content: [
                {
                  required: true,
                  type: "string",
                  trigger: "change",
                },
              ],
              sort: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              status: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            { lang: 24 },
            { title: 24 },
            { sort: 24 },
            { status: 24 },
            { content: 24 },
          ],
          fields: [
            {
              name: () => this.$t("language"),
              key: "lang",
              placeholder() {
                return this.$t("select") + this.$t("language");
              },
              component: "Radio",
              options: [
                {
                  label: this.$t("Chinese"),
                  value: "zh-CN",
                  disabled: () => true,
                },
                {
                  label: this.$t("English"),
                  value: "en-US",
                  disabled: () => true,
                },
              ],
              default: "zh-CN",
              bind: {
                border: true,
              },
            },
            {
              key: "title",
              name: () => this.$t("documentName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("documentName");
              },
            },
            {
              name: () => this.$t("sort"),
              key: "sort",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              default: 99,
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              },
            },
            {
              name: () => this.$t("tip"),
              key: "status",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              component: "Radio",
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" },
              ],
              default: "ENABLE",
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("documentContent"),
              key: "content",
              solt: "ADDDOCUMENT",
              placeholder: () => this.$t("enter") + this.$t("documentContent"),
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          },
          // {
          //   key: "lang",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("language");
          //   },
          //   clearable: true,
          //   options: langL
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              show: () => {
                return this.activeName;
              },
            },
          ],
          methods: {
            addFun: () => {
              this.$refs["table"]
                .getModal("addDocument")
                .open({ category_id: this.activeName, lang: this.lang }, () => {
                  this.$refs["table"]
                    .getModal("addDocument")
                    .setTitle(this.$t("add") + this.$t("doc"));
                  this.$refs["table"].getModal("addDocument").type =
                    "addDocument";
                });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("zhTitle"),
          key: "title",
          align: "left",
        },
        // {
        //   name: () => this.$t("content"),
        //   key: "content",
        //   align: "center"
        // },
        {
          name: () => this.$t("sort"),
          key: "sort",
          align: "center",
          width: 80,
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          align: "center",
          width: 150,
        },
        {
          name: () => this.$t("tip"),
          key: "status",
          width: 100,
          render(h, { row }) {
            return h(
              "span",
              {
                style: {
                  color: row.status == "ENABLE" ? "#19b16b" : "#ed4014",
                },
              },
              row.status == "ENABLE" ? this.$t("enable") : this.$t("disable")
            );
          },
        },
        // {
        //   name: () => this.$t("operate"),
        //   key: "operator",
        //   align: "center",
        //   width: 100
        // },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            update({ row }) {
              // this.handleRequestMethods("getDetails", row.id, false, true).then(
              //   res => {
              this.getModal("addDocument").setTitle(
                this.$t("update") + ": " + row.title
              );
              this.getModal("addDocument").type = "editDocument";
              console.log(row);
              this.getModal("addDocument").open(row);
              // this.content = row.content;
              // }
              // );
            },
            delete({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("delete") +
                  this.$t("documentName") +
                  ": " +
                  row.title,
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "deleteDocument",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.search-inp {
  margin: 0px auto 10px;
  // width: 90%;
  box-sizing: border-box;
  display: flex;
  justify-items: center;
  align-items: center;
}
.ivu-menu-vertical.ivu-menu-light:after {
  display: none;
}
.loading-div {
  position: absolute;
}
.v-note-wrapper {
  z-index: 99;
  height: 500px;
}
</style>
